import { commonInputPropField } from "../request/license/request-license.condition";

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("fishingToolDeclarations.") &&
                    (
                        field?.key?.endsWith(".isResult")
                    )
                );
            },
            checkedProp: ({ props, items, item, modelRef, initialModel }) => {
                const { viewOnly } = props;
                let enabled = false;
                let parentIsChecked = true
                if (item?.refParent) {
                    parentIsChecked = items.find(d =>
                        d.id === item?.refParent?.id &&
                        d.isResult
                    )
                }
                enabled = ( !viewOnly && !!parentIsChecked) || enabled;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || !enabled;
                }
                return { ...common };
            },
        },
        {
            check: ({ field }) => {
                const check = (
                    ((field?.key?.startsWith("fishingToolDeclarations.") || (field?.key?.startsWith("refOriginal.fishingToolDeclarations.")))) &&
                    (field?.key?.endsWith(".editButton"))
                );
                return check
            },
            visibleField: ({ props ,item, items, modelRef }) => {
                let visible = false;
                const { viewOnly } = props;
                const isNotHaveChild = items.filter(child => child.refParent?.id == item.id)?.length == 0;
                if (item.isResult && isNotHaveChild) {
                    visible = true;
                }
                visible =
                    !["waitAcceptRequest", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"].includes(modelRef.refStatus?.key)
                    && visible;
                return visible && !viewOnly
            }
        },
        {
            check: ({ field }) => {
                const check = (
                    ((field?.key?.startsWith("fishingToolDeclarations.") || (field?.key?.startsWith("refOriginal.fishingToolDeclarations.")))) &&
                    (field?.key?.endsWith(".qty") || field?.key?.endsWith(".width") || field?.key?.endsWith(".duringFishing"))
                );
                return check
            },
            visibleField: ({ item, data, /*items*/ }) => {
                let visible = false;
                // const isNotHaveChild = items.filter(child => child.refParent?.id == item.id)?.length == 0;
                if (item.isResult && !data.isNotShowDetail) {
                    visible = true;
                }
                return visible
            }
        }
    ];
};
